import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Account", -1)
const _hoisted_2 = { class: "account-panel__wrapper" }
const _hoisted_3 = { class: "account-panel__information" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Theme (experimental) ")
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Change email address ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Save changes ")
const _hoisted_8 = { class: "account-panel__picture" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAlert = _resolveComponent("AppAlert")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AccountPictureUpload = _resolveComponent("AccountPictureUpload")!
  const _component_AppPanel = _resolveComponent("AppPanel")!

  return (_openBlock(), _createBlock(_component_AppPanel, { class: "account-panel" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args)), ["prevent"])),
          novalidate: ""
        }, [
          (Object.keys(_ctx.specialErrors).length > 0)
            ? (_openBlock(), _createBlock(_component_AppAlert, {
                key: 0,
                theme: "danger",
                icon: "error"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialErrors, (field) => {
                    return (_openBlock(), _createElementBlock("ul", { key: field }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(field), (error) => {
                        return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AppInput, {
              id: "account-details-first-name",
              label: "First name",
              placeholder: "First name",
              type: "text",
              error: _ctx.fieldEmptyErrors.firstName || !!_ctx.specialErrors.firstName,
              modelValue: _ctx.firstName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
              modelModifiers: { trim: true },
              maxlength: "20",
              autofocus: ""
            }, null, 8, ["error", "modelValue"]),
            _createVNode(_component_AppInput, {
              id: "account-details-last-name",
              label: "Last name",
              placeholder: "Last name",
              type: "text",
              error: _ctx.fieldEmptyErrors.lastName || !!_ctx.specialErrors.lastName,
              modelValue: _ctx.lastName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
              modelModifiers: { trim: true },
              maxlength: "20"
            }, null, 8, ["error", "modelValue"]),
            _createVNode(_component_AppInput, {
              id: "account-details-nickname",
              label: "Nickname",
              placeholder: "Nickname",
              type: "text",
              modelValue: _ctx.displayName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.displayName) = $event)),
              modelModifiers: { trim: true },
              error: !!_ctx.specialErrors.displayName,
              maxlength: "20"
            }, null, 8, ["modelValue", "error"]),
            _createVNode(_component_AppDropdown, {
              type: "simple",
              class: "mb-responsive"
            }, {
              label: _withCtx(() => [
                _hoisted_4
              ]),
              default: _withCtx(() => [
                _createVNode(_component_AppSelect, {
                  modelValue: _ctx.userTheme,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userTheme) = $event)),
                    _cache[5] || (_cache[5] = ($event: any) => (_ctx.setTheme()))
                  ],
                  options: _ctx.themeOptions,
                  min: 1,
                  "close-on-select": true,
                  placeholder: 'Select theme'
                }, _createSlots({
                  toggle: _withCtx(({ isFocusing, toggle }) => [
                    _createElementVNode("div", {
                      onClick: toggle,
                      onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"])),
                      class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                    }, [
                      _createVNode(_component_AppIcon, { name: "arrow" })
                    ], 42, _hoisted_5)
                  ]),
                  "dropdown-item": _withCtx(({ option }) => [
                    _createElementVNode("p", null, _toDisplayString(option), 1)
                  ]),
                  _: 2
                }, [
                  (_ctx.userTheme)
                    ? {
                        name: "label",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.userTheme), 1)
                        ])
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_AppInput, {
              id: "account-details-email",
              label: "Email",
              type: "email",
              placeholder: "Email",
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email) = $event)),
              modelModifiers: { trim: true },
              disabled: true,
              maxlength: "20"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_AppButton, {
              theme: "secondary",
              size: "small",
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_AppButton, {
            type: "submit",
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["loading"])
        ], 32),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_AccountPictureUpload, { id: "settings-profile-picture" })
        ])
      ])
    ]),
    _: 1
  }))
}